import { render, staticRenderFns } from "./selectCommunity.vue?vue&type=template&id=e21ecf5c&scoped=true&"
import script from "./selectCommunity.vue?vue&type=script&lang=js&"
export * from "./selectCommunity.vue?vue&type=script&lang=js&"
import style0 from "./selectCommunity.vue?vue&type=style&index=0&id=e21ecf5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21ecf5c",
  null
  
)

export default component.exports